
export const Admin: string = "Admin";

export const AdminRoles: string[] = [Admin];
